import { render, staticRenderFns } from "./SwitchNetwork.vue?vue&type=template&id=5b0858cc&"
import script from "./SwitchNetwork.vue?vue&type=script&lang=js&"
export * from "./SwitchNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SwitchNetwork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports